import { $api } from '../generated/client';

export function useSearchProducts(shopId: string, q: string) {
  return $api.useQuery('get', '/shops/{shopId}/products', {
    params: {
      path: { shopId },
      query: q ? { q } : {},
    },
  });
}
